import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MbPlansComponent } from './mb-plans.component';

const routes: Routes = [
  {
    path: '',
    component: MbPlansComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MbPlansRoutingModule { }
